import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { UiCheckboxComponent } from '@system-dyg/shared/ui';
import { AppExampleSectionComponent } from '../../components/ds-example-section/ds-example-section.component';

@Component({
  selector: 'app-checkbox-doc',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiCheckboxComponent, AppExampleSectionComponent],
  templateUrl: './checkbox-doc.component.html',
  styleUrl: './checkbox-doc.component.scss',
})
export class CheckboxDocComponent {
  protected readonly acceptTerms = signal(false);
  protected readonly newsletter = signal(true);
  protected readonly selectAll = signal(false);
  protected readonly isInvalid = signal(false);
  protected readonly showErrorMsg = signal(true);

  protected toggleInvalid(): void {
    this.isInvalid.update((v) => !v);
  }

  protected toggleErrorMsg(): void {
    this.showErrorMsg.update((v) => !v);
  }
}
